/**
 * Resolve Camera Measurement identity for a Safety Scan window.
 * Never guesses a device. Never uses camera_id-only.
 */

import { resolveCameraMeasurementIdentity } from './cameraMeasurementPresentation';

export type ScanMeasurementSource = {
  siteId?: string | null;
  deviceId?: string | null;
  cameraId?: string | null;
  inventoryDeviceId?: string | null;
  zoneId?: string | null;
  zoneName?: string | null;
  zoneVersion?: number | null;
  windowStart?: string | null;
  windowEnd?: string | null;
  signed?: boolean;
};

export type ResolvedScanMeasurementSource =
  | {
    ok: true;
    siteId: string;
    deviceId: string;
    cameraId: string;
    zoneId: string | null;
    zoneName: string | null;
    zoneVersion: number | null;
    windowStart: string;
    windowEnd: string;
    signed: boolean;
  }
  | {
    ok: false;
    reason: 'missing_identity' | 'device_unresolved' | 'missing_window';
  };

function text(value?: string | null): string {
  return String(value || '').trim();
}

export function resolveScanMeasurementSource(source: ScanMeasurementSource): ResolvedScanMeasurementSource {
  const windowStart = text(source.windowStart);
  const windowEnd = text(source.windowEnd);
  if (!windowStart || !windowEnd) {
    return { ok: false, reason: 'missing_window' };
  }
  const identity = resolveCameraMeasurementIdentity({
    siteId: source.siteId,
    cameraId: source.cameraId,
    deviceId: source.deviceId,
    inventoryDeviceId: source.inventoryDeviceId,
  });
  if (!identity.ok) {
    return { ok: false, reason: identity.reason };
  }
  return {
    ok: true,
    siteId: identity.siteId,
    deviceId: identity.deviceId,
    cameraId: identity.cameraId,
    zoneId: text(source.zoneId) || null,
    zoneName: text(source.zoneName) || null,
    zoneVersion: source.zoneVersion == null ? null : Number(source.zoneVersion),
    windowStart,
    windowEnd,
    signed: Boolean(source.signed),
  };
}
